import { useState, useEffect } from "react";
import axios from "axios";
import { API } from "@/utils/helpers";

const BrandFooter = () => {
  const [brandsByLetter, setBrandsByLetter] = useState({});
  const [loading, setLoading] = useState(true);
  const [activeLetter, setActiveLetter] = useState('');

  useEffect(() => {
    const fetchBrands = async () => {
      try {
        const response = await axios.get(`${API}/brands/all`);
        setBrandsByLetter(response.data);
      } catch (error) {
        console.error('Error fetching brands:', error);
      } finally {
        setLoading(false);
      }
    };
    
    fetchBrands();
  }, []);

  if (loading) return null;

  const letters = Object.keys(brandsByLetter).sort();

  const scrollToLetter = (letter) => {
    const element = document.getElementById(`letter-${letter}`);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      setActiveLetter(letter);
    }
  };

  return (
    <footer className="brand-footer" data-testid="brand-footer">
      <div className="brand-footer-container">
        <h2 className="brand-footer-title">Marques A-Z</h2>
        
        <nav className="brand-alphabet-nav" data-testid="alphabet-nav">
          {letters.map(letter => (
            <button
              key={letter}
              onClick={() => scrollToLetter(letter)}
              className={`alphabet-link ${activeLetter === letter ? 'active' : ''}`}
              data-testid={`alphabet-${letter}`}
            >
              {letter}
            </button>
          ))}
        </nav>
        
        <div className="brand-columns" data-testid="brand-columns">
          {letters.map(letter => (
            <div key={letter} id={`letter-${letter}`} className="brand-section">
              <h3 className="brand-section-letter">{letter}</h3>
              <ul className="brand-links">
                {brandsByLetter[letter].map(brand => (
                  <li key={brand}>
                    <a
                      href={`/brand/${encodeURIComponent(brand)}`}
                      className="brand-link"
                      data-testid={`brand-link-${brand.toLowerCase().replace(/\s+/g, '-')}`}
                    >
                      {brand}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </footer>
  );
};

export default BrandFooter;
